/** Trim and lower-case for case-insensitive search matching. */
export function normalizeSearchText(value?: string): string {
  return (value ?? "").trim().toLowerCase();
}
